export const createBrandConfig = (brandConfiguration) => ({
    brandConfiguration,
});
